
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import axios from 'axios';
import Backend from '../../utils/Backend';
import { toast } from 'react-toastify';

import Loader from '../Loader';
import RadioButtonsSearch from '../RadioButtonsSearch';

import IGenericOption from '../../interfaces/IGenericOption';

interface IPreferredDealership {
  dealership?: any;
  setDealership(dealership?: any): void;
  makeId: string,
  vehicle_type: string,
  disabled?: boolean,
  customDealership?: string;
  setCustomDealership?(dealership?: string): void;
}

const PreferredDealership = ({ 
  dealership, setDealership, makeId, vehicle_type, disabled, 
  customDealership, setCustomDealership 
} : IPreferredDealership ) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("Dealerships not found")

  const [options, setOptions] = useState<IGenericOption[]>([]);
  const [fetched, setFetched] = useState(false);

  const router = useRouter()

  useEffect(() => {
    if (!fetched) {
      const { promise, cancel } = Backend.getDealershipsByMake(makeId, vehicle_type)
  
      promise.then(({ data }) => {
        let dealerships: any[] = data.content;

        // Sort dealerships by name alphabetically
				dealerships.sort((a, b) => a.name.localeCompare(b.name));
        
        dealerships.forEach((dealership: any) => {
          dealership.label = dealership.name + " - " + dealership.county
        })
  
        setOptions(dealerships)
        setLoading(false);
        setFetched(true);
      })
  
      .catch((err) => {
        if (axios.isCancel(err)) return;
        
        const message = "Failed to fetch dealerships";
        setError(message)
        toast.error(message);
  
        setLoading(false);
      })
  
      return cancel;
    }
  }, [makeId, vehicle_type, setDealership, fetched]);

  // checking dealership from router
  useEffect(() => {
    if (router.isReady && !!!customDealership && setCustomDealership && options.length) {
      
      const dealership_url = router.query.dealership as string;
      if (!!!dealership_url) return;

      const dealerships = options.filter((dealership: any) => dealership.name && dealership.name.includes(dealership_url))

      // Sort dealerships by name alphabetically
			dealerships.sort((a, b) => a.label.localeCompare(b.label));

      if (!!!dealerships.length) {
        toast.warning("Requested dealership not found.")
        return;
      }

      setDealership(dealerships[0] ? dealerships[0] : undefined)
      setOptions(dealerships)
      setCustomDealership(dealership_url);
    }
  }, [router, options, customDealership, setCustomDealership, setDealership])  

  return (
    <div>
      { loading ? <Loader /> : (
        <RadioButtonsSearch 
          selected={dealership}
          setSelected={setDealership}
          options={options}
          placeholder="Search by Dealership or Location"
          customErrorMsg={error}
          maxHeight={285}
          disabled={disabled}
          hideSearch={!!customDealership}
        />
      )}
    </div>
  );
};

export default PreferredDealership;